/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Item } from './Item'
import {
  ItemFromJSON,
  ItemFromJSONTyped,
  ItemToJSON,
  ItemToJSONTyped,
} from './Item'
import type { Sale2Item } from './Sale2Item'
import {
  Sale2ItemFromJSON,
  Sale2ItemFromJSONTyped,
  Sale2ItemToJSON,
  Sale2ItemToJSONTyped,
} from './Sale2Item'

/**
 *
 * @export
 * @interface SaleItem
 */
export interface SaleItem {
  /**
   *
   * @type {Sale2Item}
   * @memberof SaleItem
   */
  saleInfo: Sale2Item
  /**
   *
   * @type {Item}
   * @memberof SaleItem
   */
  itemInfo: Item
}

/**
 * Check if a given object implements the SaleItem interface.
 */
export function instanceOfSaleItem(value: object): value is SaleItem {
  if (!('saleInfo' in value) || value['saleInfo'] === undefined) return false
  if (!('itemInfo' in value) || value['itemInfo'] === undefined) return false
  return true
}

export function SaleItemFromJSON(json: any): SaleItem {
  return SaleItemFromJSONTyped(json, false)
}

export function SaleItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SaleItem {
  if (json == null) {
    return json
  }
  return {
    saleInfo: Sale2ItemFromJSON(json['saleInfo']),
    itemInfo: ItemFromJSON(json['itemInfo']),
  }
}

export function SaleItemToJSON(json: any): SaleItem {
  return SaleItemToJSONTyped(json, false)
}

export function SaleItemToJSONTyped(
  value?: SaleItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    saleInfo: Sale2ItemToJSON(value['saleInfo']),
    itemInfo: ItemToJSON(value['itemInfo']),
  }
}
